import { AppBar, AppBarProps, styled, Toolbar, Typography } from '@mui/material';
import React from 'react';

interface HeaderBarProps extends AppBarProps {
  heading: string;
  titleId: string;
  rightComponent?: React.ReactNode;
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `0.2px solid ${theme.palette.brandBackgroundSecondary.main}`,
  borderLeft: 'none',
  borderBottom: 'none',
  color: theme.palette.text.primary,
}));
const StyledToolbar = styled(Toolbar)(() => ({
  justifyContent: 'space-between',
}));

export const HeaderBar = ({ heading, rightComponent, titleId, ...restProps }: HeaderBarProps) => (
  <StyledAppBar elevation={2} position="sticky" aria-labelledby={titleId} {...restProps}>
    <StyledToolbar>
      <Typography variant="h6" id={titleId}>
        {heading}
      </Typography>
      {rightComponent}
    </StyledToolbar>
  </StyledAppBar>
);
